import React from 'react'
import { FaCircle, FaCheckCircle } from 'react-icons/fa'
import { Box, Heading, Icon } from '@/components/lib'

function RadioHeader ({ name, value, checked, onChange, title, content }) {
  return (
    <Box display='flex' flexDirection='column' alignItems='center'>
      <Box mb={3} onClick={() => onChange(true)}>
        {!checked
          ? (
            <Icon color='fg.subtle'><FaCircle /></Icon>)
          : (
            <Icon color='green.500'><FaCheckCircle /></Icon>
            )}
      </Box>
      <Box textAlign='center' flex='1' onClick={e => onChange(true)}>
        <Heading cursor='pointer' as='h4' size='md'>{title}</Heading>
        {content}
      </Box>
    </Box>
  )
}

export default RadioHeader
